export function ShapeTabIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14">
			<path
				d="M7 12.5C7 12.5 3 8.2 3 5.5A4 4 0 0 1 11 5.5C11 8.2 7 12.5 7 12.5ZM7 3.9A1.6 1.6 0 1 0 7 7.1A1.6 1.6 0 1 0 7 3.9Z"
				stroke="none"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
